import { CodeListStatus, PassOrFail } from "@gtpl/shared-models/common-models";

export class QcClearanceDTO {
    codeListMainId:number;
    soId: number;
    poNumber: string;
    soItemId: number;
    createdUser: string;
    updatedUser: string;
    createdAt?: Date;
    updatedAt?: Date;
    versionFlag?: number;
    chemicalResult?: PassOrFail;
    microResult?: PassOrFail;
    fgResult?: PassOrFail;
    others?: PassOrFail;
    cFile?: string;
    mFile?: string;
    fgFile?: string;
    othersFile?: string;
    clearanceStatus?: CodeListStatus;
    overallResult?:PassOrFail;
    clearanceId?: number
    testType?: string

    constructor(
        codeListMainId: number,
        soId: number,
        poNumber: string,
        soItemId: number,
        createdUser: string,  
        updatedUser: string, 
        createdAt?: Date,
        updatedAt?: Date,
        versionFlag?: number,
        chemicalResult?: PassOrFail,
        microResult?: PassOrFail,
        fgResult?: PassOrFail,
        others?: PassOrFail,
        cFile?: string,
        mFile?: string,
        fgFile?: string,
        othersFile?: string,
        clearanceStatus?: CodeListStatus,
        overallResult?:PassOrFail,
        clearanceId?: number,
        testType?: string
    ) {
        this.codeListMainId = codeListMainId;
        this.soId = soId;
        this.poNumber = poNumber;
        this.soItemId = soItemId;
        this.createdUser = createdUser;
        this.updatedUser = updatedUser;
        this.createdAt = createdAt;
        this.updatedAt = updatedAt;
        this.versionFlag = versionFlag;
        this.chemicalResult = chemicalResult;
        this.microResult = microResult;
        this.fgResult = fgResult;
        this.others = others;
        this.cFile = cFile;
        this.mFile = mFile;
        this.fgFile = fgFile;
        this.othersFile = othersFile;
        this.clearanceStatus = clearanceStatus;
        this.overallResult = overallResult
        this.clearanceId = clearanceId
        this.testType = testType
    }
}
